<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<page-content>
  <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
  <mat-tab-group *ngIf="parentEntries.length && finalMenuItemElement.length && !isLoading">
    <mat-tab label="Menu Items">
      <ngx-json-viewer [expanded]="false" [json]="finalMenuItemElement"></ngx-json-viewer>
    </mat-tab>
    <mat-tab label="Content Entries">
      <ngx-json-viewer [expanded]="false" [json]="parentEntries"></ngx-json-viewer>
    </mat-tab>
  </mat-tab-group>

  <ngx-json-viewer *ngIf="parentEntries.length && !finalMenuItemElement.length && !isLoading"
                   [expanded]="false" [json]="parentEntries"></ngx-json-viewer>

  <ngx-json-viewer *ngIf="!parentEntries.length && finalMenuItemElement.length && !isLoading"
                   [expanded]="false" [json]="finalMenuItemElement"></ngx-json-viewer>
</page-content>
